module.exports = __webpack_public_path__ + "assets/img/tutorial.ba175ccb.svg";